<script lang="ts" setup>
  import type Login from '~/components/Login/index.vue'
  import { ELocale } from '~/types/enums'

  const Header = defineAsyncComponent(() => import('~/components/Header/index.vue'))
  const HeaderEn = defineAsyncComponent(() => import('~/componentsEn/HeaderEn.vue'))
  const Footer2 = defineAsyncComponent(() => import('~/components/Footer2/index.vue'))
  const Join = defineAsyncComponent(() => import('~/components/Join/index.vue'))

  const tokenCookie = useCookie('access_token', {
    maxAge: 60 * 60 * 24 * 7,
    domain: 'jufair.com'
  })
  const route = useRoute()
  const router = useRouter()
  const globalStore = useGlobalStore()
  const i18nStore = useI18nStore()

  const showFooter = ref(true)
  const joinVisible = ref(false)
  const isSdkReady = ref(false)
  const w = ref(0)
  const url = ref('')
  const lang = ref(i18nStore.locale)

  const { t } = useI18n()

  const visibleLinks = computed(() => {
    const { path } = route
    return path === '/' || /^\/exhibition((-\d+){7}|)\/$/.test(path)
  })

  // 初始化函数
  const init = () => {
    ;(window as any).ysf('onready', () => {
      isSdkReady.value = true
    })
  }

  // 检查是否登录
  const shouldLogin = () => {
    if (!tokenCookie.value) {
      loginModal?.value.open()
      // router.push(`/login?redirect=${encodeURIComponent(route.fullPath)}`)
    }
    return !!tokenCookie.value
  }

  // 打开客服窗口
  const openkefu = () => {
    if (isSdkReady.value) {
      ;(window as any).ysf('open')
    }
  }

  const isLogin = computed(() => globalStore.isLogin)
  const loginModal = inject<typeof Login>('loginModal')
  const handleLogin = () => {
    // window.$login.show(window.$i18n);
    // console.log("loginModal", app);
    if (tokenCookie.value) {
      window.open('/manager/', '_blank')
    } else {
      loginModal?.value.open()
    }
  }

  // 打开新窗口
  const openWindow = (path: string) => {
    if (shouldLogin()) {
      window.open(path, '_blank')
    }
  }

  // 处理 Sidebar 变化
  const sidebarChange = (e: any) => {
    w.value = e
  }

  // 在组件挂载时执行逻辑
  onMounted(() => {
    const routerPath = route.path
    url.value = routerPath.substr(1, routerPath.indexOf('/', 1) - 1)
  })

  onBeforeMount(() => {
    const { name } = route

    if (name === '选择支付方式') {
      showFooter.value = false
    }
  })

  // 错误捕获
  const errorCaptured = (err: any, vm: any, info: any) => {
    if (process.client) {
      const fundebug = require('fundebug-javascript')
      fundebug.notify('ErrorCaptured', `${info}-layouts/default.vue-98`, {
        metaData: { err, vm, info }
      })
    } else {
      console.error('ErrorCaptured', err)
    }
    return false
  }

  // 配置 `head`
  const head = () => {
    const meta = [
      {
        name: 'og:image',
        content: 'https://www.jufair.com/logo.png'
      }
    ]
    let currentPageUrlStr = route.fullPath
    if (route.fullPath.includes('/seo')) {
      currentPageUrlStr = route.fullPath.split('/seo')[1]
    }

    const link = [
      {
        rel: 'canonical',
        href: `https://www.jufair.com${currentPageUrlStr}`
      }
    ]

    const head: Record<string, any> = {}
    if (
      !/exhibition\/\d+\.html/.test(route.path) &&
      !/information\/\d+\.html/.test(route.path) &&
      !/information/.test(route.path)
    ) {
      head.meta = meta
    }
    if (
      !/exhibition(-\d+){7}/.test(route.path) &&
      !/information(-\d+){3}/.test(route.path) &&
      !/information/.test(route.path)
    ) {
      head.link = link
    }

    return head
  }

  // return {
  //   _,
  //   lang: i18nStore.locale,
  //   visibleLinks,
  //   showFooter,
  //   joinVisible,
  //   isSdkReady,
  //   w,
  //   url,
  //   init,
  //   shouldLogin,
  //   openkefu,
  //   openWindow,
  //   handleLogin,
  //   sidebarChange,
  //   errorCaptured,
  //   head
  // }
  // }
  // })
</script>

<template>
  <div class="layout-container">
    <!-- <Sidebar @on-change="sidebarChange"></Sidebar> -->
    <div
      :style="`padding-left: ${w}px`"
      class="main-container">
      <!-- <div>{{ lang }}--{{ ELocale.en }}</div> -->
      <HeaderEn v-if="lang === ELocale.en" />
      <Header v-else />
      <main>
        <slot />
      </main>
      <Footer2
        v-if="showFooter"
        :visible-links="visibleLinks" />
      <!-- <div v-if="url !== 'exhibition'" class="slider-area"> -->
      <div
        v-if="url !== 'exhibition'"
        class="slider-area">
        <ul>
          <li class="tel">
            <div class="box">
              <img
                alt="icon"
                src="~/assets/icon/tel-icon.png" />
              <span>{{ t('fixed_sidebar.phone') }}</span>
            </div>
            <div class="tel-no">
              <div style="margin-bottom: 6px">{{ t('fixed_sidebar.booth') }}：0571-88683357</div>
              <div>{{ t('fixed_sidebar.viewer') }}：0571-88611413</div>
            </div>
          </li>
          <li>
            <!-- http://wpa.qq.com/msgrd?v=3&uin=61882907&site=在线客服&menu=yes -->
            <!-- <a href="http://qfck70.kuaishang.cn/bs/im.htm?cas=3444___376684&fi=3934" rel="nofollow" title="在线客服"> -->
            <a
              :title="t('fixed_sidebar.online_customer')"
              href="JavaScript:KS.openDirChatWin()"
              rel="nofollow">
              <!-- <a @click="openkefu()" title="在线客服"> -->
              <img
                alt="icon"
                src="~/assets/icon/service.png" />
              <span>{{ t('fixed_sidebar.customer') }}</span>
            </a>
          </li>
          <!-- handleLogin -->
          <!-- @click="openWindow('/manager/')" -->
          <li @click="handleLogin">
            <img
              alt="icon"
              src="~/assets/icon/my.png" />
            <span>{{ t('fixed_sidebar.my') }}</span>
          </li>
          <li @click="openWindow('/manager/ticket-my/')">
            <img
              alt="icon"
              src="~/assets/icon/ticket.png" />
            <span>{{ t('fixed_sidebar.vote') }}</span>
          </li>
          <li @click="joinVisible = true">
            <span style="white-space: pre-wrap">
              {{ t('fixed_sidebar.cooperate') }}
            </span>
          </li>
        </ul>
      </div>
      <Join
        :visible="joinVisible"
        @close="joinVisible = false" />
    </div>
  </div>
</template>
